import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

type Role = {
  id: string;
  name: string;
};

type CompanyRoleIndexResponse = Role[];

export const companyRoleApiClient = {
  index: async (): Promise<ApiResult<CompanyRoleIndexResponse>> => {
    return await axiosClient.get('/company/company-roles');
  },
};
